/* "Recently viewed" row (sections/theme-recently-viewed.liquid).
   Reads Horizon's localStorage list (viewedProducts), drops the page product and asks
   the search page for those ids rendered as cards by sections/theme-card-results.liquid. */
(() => {
  const init = async () => {
    const wrap = document.querySelector('[data-mv-recent]');
    if (!wrap || wrap.dataset.mvReady) return;
    wrap.dataset.mvReady = '1';
    let ids = [];
    try {
      ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
    } catch (e) {
      ids = [];
    }
    if (!Array.isArray(ids)) return;
    const current = String(wrap.dataset.currentId || '');
    const max = parseInt(wrap.dataset.max || '4', 10) || 4;
    ids = ids.map(String).filter((id) => /^\d+$/.test(id) && id !== current).slice(0, max);
    if (!ids.length) return;

    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${root}search`, location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', 'theme-card-results');
    try {
      const res = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const items = [...doc.querySelectorAll('.mv-card-results__item')];
      const byId = new Map(items.map((el) => [el.dataset.productId, el]));
      const list = wrap.querySelector('[data-mv-recent-list]');
      if (!list) return;
      let n = 0;
      for (const id of ids) {
        const item = byId.get(id);
        if (!item || !item.querySelector('.mv-card')) continue;
        const li = document.createElement('li');
        li.className = 'mv-related__item';
        li.append(...item.childNodes);
        list.appendChild(li);
        n += 1;
      }
      if (n >= 2) wrap.hidden = false; // one lonely card reads as a gap, so the row needs two
    } catch (e) {
      /* the row stays hidden */
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
